export default __webpack_public_path__ + "static/media/total-call.91aa0ea7.svg";